import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var deserializerMiddleware = function deserializerMiddleware(options, deserializer) {
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var _yield$next, response, parsed, hint;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return next(args);
              case 2:
                _yield$next = _context.sent;
                response = _yield$next.response;
                _context.prev = 4;
                _context.next = 7;
                return deserializer(response, options);
              case 7:
                parsed = _context.sent;
                return _context.abrupt("return", {
                  response: response,
                  output: parsed
                });
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                Object.defineProperty(_context.t0, "$response", {
                  value: response
                });
                if (!("$metadata" in _context.t0)) {
                  hint = "Deserialization error: to see the raw response, inspect the hidden field {error}.$response on this object.";
                  _context.t0.message += "\n  " + hint;
                  if (typeof _context.t0.$responseBodyText !== "undefined") {
                    if (_context.t0.$response) {
                      _context.t0.$response.body = _context.t0.$responseBodyText;
                    }
                  }
                }
                throw _context.t0;
              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 11]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};